module.exports = __webpack_public_path__ + "img/sapar_yes.6de63f6a.png";